import type { DecisionEngineDestinationUI } from "./definition";

export const klaviyoUI: DecisionEngineDestinationUI = {
  campaignSetup: "event-triggered",
  resourceName: "flow",
  channelDescription: "Klaviyo",
  getReferenceString: (s) => `{{ event.${s} }}`,
  getResourceUrl: (flow) => `https://www.klaviyo.com/flow/${flow.id}/edit`,
  isInactive: (flow) => flow.status !== "live",
  isPreviewSupported: false,
  getResourceType: () => "flow",
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
  showAssociatedTemplate: true,
};
